import _ from 'lodash';
import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel } from '@mui/material';
import AutocompleteComponent from '../../../../components/Autocomplete/Autocomplete';
import Button from '../../../../components/Button/Button';
import PermissionsDataTable from '../../components/PermissionsDataTable';

function RolePermissionsComponent(props: any) {
    const {
        data,
        rowSelected,
        drawerAction,
        selectedItem,
        docTypeSelected,
        allDocumentTypes,
        handleChangeDocType,
        handleAddPermission,
        loadingAllDocumentTypes,
        fetchingAllDocumentTypes,
        permissionFormValidation,
        ...restProps
    } = props;
    return (
        <>
            {!data?.cuil && !data?.cuilUsuario && <h3>Tipos de documentos asociados</h3>}
            {drawerAction !== 'view' && (!selectedItem || !!drawerAction) && (
                <Box
                    my={2}
                    p={2}
                    display="block"
                    sx={{ background: '#E5EEF4', borderRadius: '8px' }}
                >
                    <Box>
                        <AutocompleteComponent
                            label="Tipo de documento"
                            value={docTypeSelected?.document || ''}
                            onChange={(value: any) => {
                                handleChangeDocType({
                                    target: {
                                        name: 'document',
                                        value: value || ''
                                    }
                                });
                            }}
                            getOptionDisabled={(option: any) =>
                                !!data?.permisos?.find(
                                    (i: any) => i?.tipoDocumento?.id === option?.id
                                )
                            }
                            options={_.sortBy(
                                allDocumentTypes?.map((i: any) => i?.tipoDocumento) || [],
                                ['nombre']
                            )}
                            loading={loadingAllDocumentTypes || fetchingAllDocumentTypes}
                        />
                    </Box>
                    <Box sx={{ display: 'flex' }}>
                        <FormControl sx={{ m: '8px 0', width: '100%' }} variant="standard">
                            <FormLabel component="legend">
                                <b style={{ color: '#3D3D3D' }}>Acciones permitidas</b>
                            </FormLabel>
                            <FormGroup
                                sx={{
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    '& .MuiCheckbox-root': {
                                        '& svg': {
                                            fill: 'var(--primary)'
                                        }
                                    }
                                }}
                            >
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            disabled={!docTypeSelected?.document}
                                            checked={docTypeSelected?.cargar || false}
                                            onChange={handleChangeDocType}
                                            name="cargar"
                                        />
                                    }
                                    label="Cargar"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            disabled={!docTypeSelected?.document}
                                            checked={docTypeSelected?.descargar || false}
                                            onChange={handleChangeDocType}
                                            name="descargar"
                                        />
                                    }
                                    label="Descargar"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            disabled={!docTypeSelected?.document}
                                            checked={docTypeSelected?.eliminar || false}
                                            onChange={handleChangeDocType}
                                            name="eliminar"
                                        />
                                    }
                                    label="Eliminar"
                                />
                            </FormGroup>
                        </FormControl>
                    </Box>
                    <Box display="flex" justifyContent="flex-end">
                        <Button
                            style={{ borderRadius: '8px' }}
                            disabled={permissionFormValidation}
                            onClick={handleAddPermission}
                        >
                            {drawerAction === 'edit' && rowSelected ? 'Modificar' : 'Agregar'}
                        </Button>
                    </Box>
                </Box>
            )}
            <PermissionsDataTable
                drawerAction={drawerAction}
                permisos={data?.permisos}
                selectedItem={selectedItem}
                {...restProps}
            />
        </>
    );
}

export default RolePermissionsComponent;
